<template>



    <main class="hp-bg-color-dark-90 d-flex min-vh-100" id="mainScroll">



        <!-- SIDEBAR -->
        <SidebarBody />



        <div class="hp-main-layout">

            <!-- HEADER -->
            <HeaderBody />



            <!-- MAIN CONTENT -->
            <div class="hp-main-layout-content">

                <div class="row mb-32 gy-0 dash-top">

                    <!-- POSTS -->
                    <div class="col-12">

                        <div class="row g-32">

                            <div class="col-12 col-xl-8" style="z-index: 9; padding-bottom: 1000px;">

                                <!-- <h2 class="mm-none">Subscriptions</h2> -->
                                <h2 class="dd-none" style="margin-top: -20px;"></h2>


                                <!-- TABS -->
                                <ul class="nav nav-tabs mb-12" id="myTab" role="tablist" style="overflow-x:auto;
                                flex-wrap:nowrap; scrollbar-width: none; margin-top: 10px;">
                                    <li class="nav-item" role="presentation">
                                        <h6 class="nav-link active" id="all-tab" data-bs-toggle="tab"
                                            data-bs-target="#all" role="tab" aria-controls="all" aria-selected="true"
                                            style="cursor: pointer;">All</h6>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <h6 class="nav-link" id="active-tab" data-bs-toggle="tab"
                                            data-bs-target="#active" role="tab" aria-controls="active"
                                            aria-selected="false" style="cursor: pointer;">Active</h6>
                                    </li>

                                    <li class="nav-item" role="presentation">
                                        <h6 class="nav-link" id="expired-tab" data-bs-toggle="tab"
                                            data-bs-target="#expired" role="tab" aria-controls="expired"
                                            aria-selected="false" style="cursor: pointer;">Expired</h6>
                                    </li>

                                </ul>

                                <!-- TAB CONTENT -->
                                <div class="tab-content" id="allTabContent">
                                    <!-- ALL -->
                                    <div class="tab-pane fade show active" id="all" role="tabpanel"
                                        aria-labelledby="all-tab">

                                        <div >
                                            <div>
                                                <div class="row">

                                                    <!-- SINGLE SUB -->
                                                    <div class="col-12 col-xl-6" style="margin-bottom: 10px;"
                                                        v-for="(sub, index) in subList" :key="'number' + index">
                                                        <div class="card hp-card-4" >

                                                            <img :src="sub.modelProfileBack" alt="" style="width: 100%; height: 100px; object-fit: cover; border-top-left-radius: 20px; border-top-right-radius: 20px;" >

                                                            <div style="width: 100%; height: 100px; object-fit: cover; border-top-left-radius: 20px; border-top-right-radius: 20px; background-color: rgba(0,0,0,0.6); margin-top: -100px;"></div>

                                                            <div class="card-body" style="margin-top: -105px;">

                                                                <i v-if="sub.status == 'active'" class="hp-text-color-dark-0 ri-2x ri-more-2-fill"
                                                                    data-bs-toggle="dropdown"
                                                                    style="cursor: pointer; position: absolute; top: 40px; right: 20px; color: #fff;"></i>

                                                                <ul class="dropdown-menu " style="cursor: pointer;">

                                                                    <li @click="openMessage()">
                                                                        <div class="dropdown-item dp-hov"
                                                                            style="display: flex; justify-content: center; align-items: center;">
                                                                            <span class="submenu-item-icon">
                                                                                <i class="hp-text-color-dark-0 ri-2 ri-mail-line"
                                                                                    style="font-size: 20px;"></i>
                                                                            </span>

                                                                            <span
                                                                                style="text-align: start; width: 100%; padding-right: 50px; margin-top: -6px; margin-left: 10px;">Message</span>
                                                                        </div>
                                                                    </li>

                                                                    <li>
                                                                        <div class="dropdown-item dp-hov"
                                                                            style="display: flex; justify-content: center; align-items: center;" data-bs-toggle="modal"
                                                                            data-bs-target="#sendTip" @click="tipClick(sub)">
                                                                            <span class="submenu-item-icon rounded-circle">
                                                                                <span
                                                                                    style="font-size: 12px; font-weight: 700; border-color: black; border-width: 2px; border-style: solid; border-radius: 50%; padding: 3px 6px;">&#8358;</span>
                                                                            </span>
                                                                            <span
                                                                                style="text-align: start; width: 100%; padding-right: 50px; margin-top: 0px; margin-left: 10px;">Send
                                                                                tip</span>
                                                                        </div>
                                                                    </li>

                                                                    <li>
                                                                        <hr class="dropdown-divider">
                                                                    </li>
                                                                    
                                                                    <li>
                                                                        <div class="dropdown-item dp-hov text-danger"
                                                                            style="display: flex; justify-content: center; align-items: center;">
                                                                            <span class="submenu-item-icon">
                                                                                <i class="hp-text-color-dark-0 ri-2 ri-flag-2-line"
                                                                                    style="font-size: 20px;"></i>
                                                                            </span>

                                                                            <span
                                                                                style="text-align: start; width: 100%; padding-right: 50px; margin-top: -6px; margin-left: 10px;">Report</span>
                                                                        </div>
                                                                    </li>

                                                                </ul>

                                                                <div class="row ">

                                                                    <div class="col">

                                                                        <div class="row align-items-center"
                                                                            style="cursor: pointer;">
                                                                            <div class="w-auto px-0"
                                                                                @click="profileClick(sub.modelId)">
                                                                                <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle"
                                                                                    style="width: 68px; height: 68px; ">
                                                                                    <img :src="sub.modelProfilePic"
                                                                                        class="hp-img-cover"
                                                                                        style="width: 68px; height: 68px; background-color: black; object-fit: cover; border-width: 1px; border-style: solid; border-color: #fff;">
                                                                                </div>
                                                                            </div>

                                                                            <div class="w-auto ms-8 px-0 mt-12"
                                                                                @click="profileClick(sub.modelId)">
                                                                                <span
                                                                                    class="d-block hp-text-color-black-0 hp-text-color-dark-0 hp-p1-body lh-1 titleM">
                                                                                    {{ sub.modelName }} </span>
                                                                                <p style="font-size: 12px; color: #fff;"
                                                                                    class="hp-badge-text fw-normal hp-text-color-dark-0 mt-4">
                                                                                    @{{ sub.modelUserName }}</p>

                                                                            </div>


                                                                        </div>

                                                                    </div>

                                                                    <div class="d-flex align-items-center justify-content-center"
                                                                        style="width: 100%; margin-top: 40px;" >

                                                                        <div
                                                                            style="display: flex; justify-content: space-between; width: 100%; align-items: center;">
                                                                            <p style="text-align: start; width: 100%;"
                                                                                class="hp-badge-text">Subscription fee
                                                                            </p>

                                                                            <p style="text-align: end; width: 100%;"
                                                                                class="hp-badge-text text-black-100 hp-text-color-dark-0">
                                                                                <span>&#8358;</span> {{ sub.priceD }}
                                                                            </p>
                                                                        </div>

                                                                    </div>

                                                                    <div class="d-flex align-items-center justify-content-center"
                                                                        style="width: 100%;">

                                                                        <div
                                                                            style="display: flex; justify-content: space-between; width: 100%; align-items: center;">
                                                                            <p style="text-align: start; width: 100%;"
                                                                                class="hp-badge-text">Subscription date
                                                                            </p>

                                                                            <p style="text-align: end; width: 100%;"
                                                                                class="hp-badge-text text-black-100 hp-text-color-dark-0">{{
                                                                                    sub.dateFull }}</p>
                                                                        </div>

                                                                    </div>

                                                                    <div class="d-flex align-items-center justify-content-center"
                                                                        style="width: 100%;">

                                                                        <div
                                                                            style="display: flex; justify-content: space-between; width: 100%; align-items: center;">
                                                                            <p style="text-align: start; width: 100%;"
                                                                                class="hp-badge-text">Expiry date</p>

                                                                            <p style="text-align: end; width: 100%;"
                                                                                class="hp-badge-text text-black-100 hp-text-color-dark-0">{{
                                                                                    sub.endDate }}</p>
                                                                        </div>

                                                                    </div>

                                                                    <div class="d-flex align-items-center justify-content-center"
                                                                        style="width: 100%;">

                                                                        <div
                                                                            style="display: flex; justify-content: space-between; width: 100%; align-items: center;">
                                                                            <p style="text-align: start; width: 100%;"
                                                                                class="hp-badge-text">Status</p>

                                                                            <p v-if="sub.status == 'active'"
                                                                                style="text-align: end; width: 100%;"
                                                                                class="hp-badge-text text-black-100">
                                                                                <span
                                                                                    class="badge bg-success-4 hp-bg-dark-success text-success border-none w-auto py-8 px-16 fw-medium">
                                                                                    Active </span>
                                                                            </p>

                                                                            <p v-else
                                                                                style="text-align: end; width: 100%;"
                                                                                class="hp-badge-text text-black-100">
                                                                                <span
                                                                                    class="badge bg-danger-4 hp-bg-dark-danger text-danger border-none w-auto py-8 px-16 fw-medium">
                                                                                    Expired </span>
                                                                            </p>
                                                                        </div>

                                                                    </div>

                                                                    <div class="divider mt-8 mb-16"></div>

                                                                </div>

                                                                <div
                                                                    class="d-flex justify-content-center align-items-center">

                                                                    <button data-bs-toggle="modal"
                                                                        data-bs-target="#unsub"
                                                                        @click="unsubClick(sub.modelId, sub.modelUserName, sub.modelProfilePic, sub.modelName, sub.email)"
                                                                        class="btn btn-danger"
                                                                        v-if="sub.status == 'active'">Unsubscribe</button>

                                                                    <button class="btn btn-primary" v-else
                                                                        @click="subscribe(sub)">Subscribe</button>

                                                                </div>

                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div style="margin-top: 200px; margin-bottom: 400px; display: none ; justify-content: center; align-items: center; flex-direction: column;"
                                                        id="emptySub">
                                                        <p class="hp-badge-text" id="emptySubText">No subscriptions yet...</p>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <!-- ACTIVE -->
                                    <div class="tab-pane fade" id="active" role="tabpanel" aria-labelledby="active-tab">

                                        <div >
                                            <div>
                                                <div class="row">

                                                    <!-- SINGLE SUB -->
                                                    <div class="col-12 col-xl-6" style="margin-bottom: 10px;"
                                                        v-for="(sub, index) in subListA" :key="'number' + index">
                                                        <div class="card hp-card-4" style="border-radius: 10px;">

                                                            <img :src="sub.modelProfileBack" alt="" style="width: 100%; height: 100px; object-fit: cover; border-top-left-radius: 20px; border-top-right-radius: 20px;" >

                                                            <div style="width: 100%; height: 100px; object-fit: cover; border-top-left-radius: 20px; border-top-right-radius: 20px; background-color: rgba(0,0,0,0.6); margin-top: -100px;"></div>

                                                            <div class="card-body" style="margin-top: -105px;">

                                                                <i class="hp-text-color-dark-0 ri-2x ri-more-2-fill"
                                                                    data-bs-toggle="dropdown"
                                                                    style="cursor: pointer; position: absolute; top: 40px; right: 20px; color: #fff;"></i>

                                                                <ul class="dropdown-menu " style="cursor: pointer;">

                                                                    <li @click="openMessage()">
                                                                        <div class="dropdown-item dp-hov"
                                                                            style="display: flex; justify-content: center; align-items: center;">
                                                                            <span class="submenu-item-icon">
                                                                                <i class="hp-text-color-dark-0 ri-2 ri-mail-line"
                                                                                    style="font-size: 20px;"></i>
                                                                            </span>

                                                                            <span
                                                                                style="text-align: start; width: 100%; padding-right: 50px; margin-top: -6px; margin-left: 10px;">Message</span>
                                                                        </div>
                                                                    </li>

                                                                    <li>
                                                                        <div class="dropdown-item dp-hov"
                                                                            style="display: flex; justify-content: center; align-items: center;" data-bs-toggle="modal"
                                                                            data-bs-target="#sendTip" @click="tipClick(sub)">
                                                                            <span class="submenu-item-icon rounded-circle">
                                                                                <span
                                                                                    style="font-size: 12px; font-weight: 700; border-color: black; border-width: 2px; border-style: solid; border-radius: 50%; padding: 3px 6px;">&#8358;</span>
                                                                            </span>
                                                                            <span
                                                                                style="text-align: start; width: 100%; padding-right: 50px; margin-top: 0px; margin-left: 10px;">Send
                                                                                tip</span>
                                                                        </div>
                                                                    </li>

                                                                    <li>
                                                                        <hr class="dropdown-divider">
                                                                    </li>
                                                                    
                                                                    <li>
                                                                        <div class="dropdown-item dp-hov text-danger"
                                                                            style="display: flex; justify-content: center; align-items: center;">
                                                                            <span class="submenu-item-icon">
                                                                                <i class="hp-text-color-dark-0 ri-2 ri-flag-2-line"
                                                                                    style="font-size: 20px;"></i>
                                                                            </span>

                                                                            <span
                                                                                style="text-align: start; width: 100%; padding-right: 50px; margin-top: -6px; margin-left: 10px;">Report</span>
                                                                        </div>
                                                                    </li>

                                                                </ul>

                                                                <div class="row ">

                                                                    <div class="col">

                                                                        <div class="row align-items-center">
                                                                            <div class="w-auto px-0">
                                                                                <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle"
                                                                                    style="width: 68px; height: 68px; ">
                                                                                    <img :src="sub.modelProfilePic"
                                                                                        class="hp-img-cover"
                                                                                        style="width: 68px; height: 68px; background-color: black; object-fit: cover; border-width: 1px; border-style: solid; border-color: #fff;">
                                                                                </div>
                                                                            </div>

                                                                            <div class="w-auto ms-8 px-0 mt-12">
                                                                                <span
                                                                                    class="d-block hp-text-color-black-0 hp-text-color-dark-0 hp-p1-body lh-1 titleM">
                                                                                    {{ sub.modelName }} </span>
                                                                                <p style="font-size: 12px; color: #fff;"
                                                                                    class="hp-badge-text fw-normal hp-text-color-dark-30 mt-4">
                                                                                    @{{ sub.modelUserName }}</p>

                                                                            </div>


                                                                        </div>

                                                                    </div>

                                                                    <div class="d-flex align-items-center justify-content-center"
                                                                        style="width: 100%; margin-top: 40px;">

                                                                        <div
                                                                            style="display: flex; justify-content: space-between; width: 100%; align-items: center;">
                                                                            <p style="text-align: start; width: 100%;"
                                                                                class="hp-badge-text">Subscription fee
                                                                            </p>

                                                                            <p style="text-align: end; width: 100%;"
                                                                                class="hp-badge-text text-black-100 hp-text-color-dark-0">&#8358;
                                                                                {{ sub.priceD }}</p>
                                                                        </div>

                                                                    </div>

                                                                    <div class="d-flex align-items-center justify-content-center"
                                                                        style="width: 100%;">

                                                                        <div
                                                                            style="display: flex; justify-content: space-between; width: 100%; align-items: center;">
                                                                            <p style="text-align: start; width: 100%;"
                                                                                class="hp-badge-text">Subscription date
                                                                            </p>

                                                                            <p style="text-align: end; width: 100%;"
                                                                                class="hp-badge-text text-black-100 hp-text-color-dark-0">{{
                                                                                    sub.dateFull }}</p>
                                                                        </div>

                                                                    </div>

                                                                    <div class="d-flex align-items-center justify-content-center"
                                                                        style="width: 100%;">

                                                                        <div
                                                                            style="display: flex; justify-content: space-between; width: 100%; align-items: center;">
                                                                            <p style="text-align: start; width: 100%;"
                                                                                class="hp-badge-text">Expiry date</p>

                                                                            <p style="text-align: end; width: 100%;"
                                                                                class="hp-badge-text text-black-100 hp-text-color-dark-0">{{
                                                                                    sub.endDate }}</p>
                                                                        </div>

                                                                    </div>

                                                                    <div class="d-flex align-items-center justify-content-center"
                                                                        style="width: 100%;">

                                                                        <div
                                                                            style="display: flex; justify-content: space-between; width: 100%; align-items: center;">
                                                                            <p style="text-align: start; width: 100%;"
                                                                                class="hp-badge-text">Status</p>

                                                                            <p v-if="sub.status == 'active'"
                                                                                style="text-align: end; width: 100%;"
                                                                                class="hp-badge-text text-black-100 hp-text-color-dark-0">
                                                                                <span
                                                                                    class="badge bg-success-4 hp-bg-dark-success text-success border-none w-auto py-8 px-16 fw-medium">
                                                                                    Active </span>
                                                                            </p>

                                                                            <p v-else
                                                                                style="text-align: end; width: 100%;"
                                                                                class="hp-badge-text text-black-100">
                                                                                <span
                                                                                    class="badge bg-danger-4 hp-bg-dark-danger text-danger border-none w-auto py-8 px-16 fw-medium">
                                                                                    Expired </span>
                                                                            </p>
                                                                        </div>

                                                                    </div>

                                                                    <div class="divider mt-8 mb-16"></div>

                                                                </div>

                                                                <div
                                                                    class="d-flex justify-content-center align-items-center">

                                                                    <button data-bs-toggle="modal"
                                                                        data-bs-target="#unsub"
                                                                        @click="unsubClick(sub.modelId, sub.modelUserName, sub.modelProfilePic, sub.modelName, sub.email)"
                                                                        class="btn btn-danger"
                                                                        v-if="sub.status == 'active'">Unsubscribe</button>

                                                                    <button class="btn btn-primary" v-else
                                                                        @click="subscribe(sub)">Subscribe</button>

                                                                </div>

                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div v-if="subListA.length < 1" style="margin-top: 200px; margin-bottom: 400px; display: flex; justify-content: center; align-items: center; flex-direction: column;" id="emptySubA">
                                                        <p class="hp-badge-text">No active subscriptions...</p>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <!-- EXPIRED -->
                                    <div class="tab-pane fade" id="expired" role="tabpanel"
                                        aria-labelledby="expired-tab">
                                        <div >
                                            <div >
                                                <div class="row">

                                                    <!-- SINGLE SUB -->
                                                    <div class="col-12 col-xl-6" style="margin-bottom: 10px;"
                                                        v-for="(sub, index) in subListE" :key="'number' + index">
                                                        <div class="card hp-card-4" style="border-radius: 10px;">

                                                            <img :src="sub.modelProfileBack" alt="" style="width: 100%; height: 100px; object-fit: cover; border-top-left-radius: 20px; border-top-right-radius: 20px;" >

                                                            <div style="width: 100%; height: 100px; object-fit: cover; border-top-left-radius: 20px; border-top-right-radius: 20px; background-color: rgba(0,0,0,0.6); margin-top: -100px;"></div>

                                                            <div class="card-body" style="margin-top: -105px;">

                                                                <div class="row ">

                                                                    <div class="col">

                                                                        <div class="row align-items-center">
                                                                            <div class="w-auto px-0">
                                                                                <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle"
                                                                                    style="width: 68px; height: 68px; ">
                                                                                    <img :src="sub.modelProfilePic"
                                                                                        class="hp-img-cover"
                                                                                        style="width: 68px; height: 68px; background-color: black; object-fit: cover; border-width: 1px; border-style: solid; border-color: #fff;">
                                                                                </div>
                                                                            </div>

                                                                            <div class="w-auto ms-8 px-0 mt-12">
                                                                                <span
                                                                                    class="d-block hp-text-color-black-0 hp-text-color-dark-0 hp-p1-body lh-1 titleM">
                                                                                    {{ sub.modelName }} </span>
                                                                                <p style="font-size: 12px; color: #fff;"
                                                                                    class="hp-badge-text fw-normal hp-text-color-dark-30 mt-4">
                                                                                    @{{ sub.modelUserName }}</p>

                                                                            </div>


                                                                        </div>

                                                                    </div>

                                                                    <div class="d-flex align-items-center justify-content-center"
                                                                        style="width: 100%; margin-top: 40px;">

                                                                        <div
                                                                            style="display: flex; justify-content: space-between; width: 100%; align-items: center;">
                                                                            <p style="text-align: start; width: 100%;"
                                                                                class="hp-badge-text">Subscription fee
                                                                            </p>

                                                                            <p style="text-align: end; width: 100%;"
                                                                                class="hp-badge-text text-black-100 hp-text-color-dark-0">&#8358;
                                                                                {{ sub.priceD }}</p>
                                                                        </div>

                                                                    </div>

                                                                    <div class="d-flex align-items-center justify-content-center"
                                                                        style="width: 100%;">

                                                                        <div
                                                                            style="display: flex; justify-content: space-between; width: 100%; align-items: center;">
                                                                            <p style="text-align: start; width: 100%;"
                                                                                class="hp-badge-text">Subscription date
                                                                            </p>

                                                                            <p style="text-align: end; width: 100%;"
                                                                                class="hp-badge-text text-black-100 hp-text-color-dark-0">{{
                                                                                    sub.dateFull }}</p>
                                                                        </div>

                                                                    </div>

                                                                    <div class="d-flex align-items-center justify-content-center"
                                                                        style="width: 100%;">

                                                                        <div
                                                                            style="display: flex; justify-content: space-between; width: 100%; align-items: center;">
                                                                            <p style="text-align: start; width: 100%;"
                                                                                class="hp-badge-text">Expiry date</p>

                                                                            <p style="text-align: end; width: 100%;"
                                                                                class="hp-badge-text text-black-100 hp-text-color-dark-0">{{
                                                                                    sub.endDate }}</p>
                                                                        </div>

                                                                    </div>

                                                                    <div class="d-flex align-items-center justify-content-center"
                                                                        style="width: 100%;">

                                                                        <div
                                                                            style="display: flex; justify-content: space-between; width: 100%; align-items: center;">
                                                                            <p style="text-align: start; width: 100%;"
                                                                                class="hp-badge-text">Status</p>

                                                                            <p v-if="sub.status == 'active'"
                                                                                style="text-align: end; width: 100%;"
                                                                                class="hp-badge-text text-black-100">
                                                                                <span
                                                                                    class="badge bg-success-4 hp-bg-dark-success text-success border-none w-auto py-8 px-16 fw-medium">
                                                                                    Active </span>
                                                                            </p>

                                                                            <p v-else
                                                                                style="text-align: end; width: 100%;"
                                                                                class="hp-badge-text text-black-100">
                                                                                <span
                                                                                    class="badge bg-danger-4 hp-bg-dark-danger text-danger border-none w-auto py-8 px-16 fw-medium">
                                                                                    Expired </span>
                                                                            </p>
                                                                        </div>

                                                                    </div>

                                                                    <div class="divider mt-8 mb-16"></div>

                                                                </div>

                                                                <div
                                                                    class="d-flex justify-content-center align-items-center">

                                                                    <button data-bs-toggle="modal"
                                                                        data-bs-target="#unsub"
                                                                        @click="unsubClick(sub.modelId, sub.modelUserName, sub.modelProfilePic, sub.modelName, sub.email)"
                                                                        class="btn btn-danger"
                                                                        v-if="sub.status == 'active'">Unsubscribe</button>

                                                                    <button class="btn btn-primary" v-else
                                                                        @click="subscribe(sub)">Subscribe</button>

                                                                </div>

                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div style="margin-top: 200px; margin-bottom: 400px; display: none; justify-content: center; align-items: center; flex-direction: column;"
                                                        id="emptySubE">
                                                        <p class="hp-badge-text">No expired subscriptions...</p>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <!-- SUGGESTIONS -->
                            <div class="col-12 col-xl-4">

                                <SuggestionsBody />

                            </div>


                        </div>

                    </div>


                </div>

                <!-- FOOTER -->
                <FooterBody />

            </div>

        </div>

    </main>

    <!-- SCROLL TO TOP -->
    <div class="scroll-to-top">
        <button type="button" class="btn btn-primary btn-icon-only rounded-circle hp-primary-shadow">
            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="16px"
                width="16px" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828z">
                    </path>
                </g>
            </svg>
        </button>
    </div>

    <!-- SUCCESS -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg"
        ref="successModal">
        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto"
                                style=" width: 200px; padding-top: 10px;">

                            <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ successText }}</p>

                            <button class="btn btn-sm btn-primary"
                                style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;"
                                @click="closeS">Okay</button>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- ERROR -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg "
        ref="errorModal">

        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            <img src="@/assets/img/errorImg.png" alt="Upgrade Account" class="hp-block mx-auto"
                                style=" width: 200px; padding-top: 30px;">

                            <h5 class="mt-24 mb-16 me-4 text-danger">Error!</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ errorText }} </p>

                            <button class="btn btn-sm btn-primary"
                                style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 20px; margin-bottom: 10px;"
                                @click="closeE">Okay</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <!-- LOADING -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg"
        ref="loadingModal">
        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">

                        <div class="col-12 text-center">
                            <img src="@/assets/img/loadingImg.png" style="width: 200px; padding-top: 20px;">
                        </div>

                        <div class="col-12 text-center">
                            <h5 class="mt-24 mb-16 me-4 ">Please wait...</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ loadingText }} </p>

                            <img src="@/assets/img/loading.gif" alt="" style="width: 60px; margin-top: 20px;">
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- UNSUB -->
    <div class="modal fade" id="unsub" tabindex="-1" aria-labelledby="unfollowLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-sm">
            <div class="modal-content">
                <div class="modal-header">

                    <h4 class="modal-title">@{{ modelUsername }}</h4>
                    <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" style="z-index: 5;"></button> -->
                </div>



                <div class="modal-body" style="margin-top: -40px;">

                    <p class="hp-p2-body" style="font-size: 12px;"> Your subscription will be terminated immediately and
                        you will lose access to all of their content </p>

                    <div class="mb-24 " style="margin-top: 40px;">
                        <label for="exampleInputEmail1" class="form-label">Reason for cancellation</label>
                        <select class="form-select form-select-sm mb-16" aria-label=" example" v-model="cancelSelect">
                            <option value="No specific reason" selected>No specific reason</option>
                            <option value="Low posting frequency">Low posting frequency</option>
                            <option value="Private messages not replied">Private messages not replied</option>
                            <option value="No longer want to be subscribed">No longer want to be subscribed</option>
                            <option value="Other">Other</option>
                        </select>
                    </div>

                    <div class="mb-24 " v-if="cancelSelect == 'Other'">
                        <label for="cancelText" class="form-label">Other</label>
                        <textarea name="cancelText" id="cancelText" class="form-control" rows="3"
                            placeholder="Type the reason here..." maxlength="200" v-model="cancelOther"
                            style="line-height: 20px; padding-top: 10px;"></textarea>
                    </div>

                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-text" data-bs-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-danger" data-bs-dismiss="modal"
                        @click="unSubscribe(modelId, modelUsername, modelProfilePic, modelName, modelEmail )">Unsubscribe</button>
                </div>
            </div>
        </div>
    </div>

    <!-- SEND TIP -->
    <div class="modal fade" id="sendTip" tabindex="-1" aria-labelledby="sendTipLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered ">
            <div class="modal-content">
                <div class="modal-header">

                    <div class="w-auto px-0" >
                        <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle" style="width: 48px; height: 48px; ">
                            <img :src="modelProfilePic" class="hp-img-cover" style=" width: 48px; height: 48px;  background-color: black; object-fit: cover; border-color: #000; border-width: 1px; border-style: solid; pointer-events: all !important;">
                        </div>
                    </div>

                    <h4 style="text-align: center; width: 100%" class="modal-title">Send Tip</h4>

                    <button style="z-index: 10;" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                        ></button>
                    
                </div>

                <div class="modal-body" style="margin-top: -40px;">

                    <!-- <p class="hp-p1-body">Send a token of appreciation to [model name]</p> -->

                    <form @submit.prevent="sendTip">

                        <div class="mb-24" style="margin-top: 30px;">

                            <label for="displayName" class="form-label">Amount</label>
                            <div class="input-group mb-16">
                                <span class="input-group-text" id="basic-addon1">&#8358;</span>
                                <input type="number" class="form-control" placeholder="100 to 50,000"
                                    aria-label="Username" aria-describedby="basic-addon1" required v-model="tip">
                            </div>

                        </div>

                        <div class="mb-24">

                            <label for="displayName" class="form-label">Message</label>
                            <textarea name="description" id="description" class="form-control" rows="4"
                                placeholder="Type a message here..." style="line-height: 20px; padding-top: 10px;"
                                v-model="message" maxlength="200"></textarea>

                        </div>

                        <div class="divider mt-18 mb-16"></div>



                        <div class="modal-footer">

                            <button type="button" class="btn btn-text" data-bs-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-primary">Confirm</button>
                        </div>

                    </form>



                </div>


            </div>
        </div>
    </div>

</template>

<script>

import SidebarBody from '@/components/SidebarBody.vue';
import HeaderBody from '@/components/HeaderBody.vue';
import SuggestionsBody from '@/components/SuggestionsBody.vue';
import FooterBody from '@/components/FooterBody.vue';
import InfiniteLoading from '../../node_modules/v3-infinite-loading/lib/v3-infinite-loading.es';
import "../../node_modules/v3-infinite-loading/lib/style.css";

import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';

import { doc, addDoc, collection, query, where, getDoc, getDocs, updateDoc, arrayUnion, serverTimestamp, orderBy, deleteDoc, increment, limit, startAfter, setDoc, Timestamp } from "firebase/firestore";
import { getAuth, onAuthStateChanged, signOut, } from "firebase/auth"
import { db } from '@/firebase';
import axios from 'axios';

export default {

    components: {
        SidebarBody,
        HeaderBody,
        SuggestionsBody,
        FooterBody,
        InfiniteLoading,
    },

    data() {
        return {

            loadingText: "",
            errorText: "",
            successText: "",
            subList: [],
            subListA: [],
            subListE: [],

            modelId: "",
            modelUsername: "",
            modelProfilePic: "",
            modelName: "",
            modelEmail: "",

            cancelSelect: "No specific reason",
            cancelOther: "",

            tip: "",
            message: "",
            tipPostId: "",

        }
    },

    mounted() {

        document.body.style.paddingRight = '0px';
        document.body.style.overflowY = 'scroll';
        document.getElementById("mobileLogo").style.display = 'none';
        document.getElementById("mobileTitle").textContent = 'Subscriptions';

        document.getElementById("subN").classList.add("active");

        document.getElementById("subN2").classList.add("active");

        //this.checkExpired();
        this.getSubList();

    },

    methods: {

        closeE() {
            this.$refs.errorModal.classList.remove("bg-active");
        },

        closeS() {
            this.$refs.successModal.classList.remove("bg-active");
            this.$router.go();
        },

        kFormatter(num) {
            return Math.abs(num) > 999 ? Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + 'k' : Math.sign(num) * Math.abs(num);

        },

        unsubClick(id, username, profilePic, name, email) {
            this.modelId = id;
            this.modelUsername = username;
            this.modelProfilePic = profilePic;
            this.modelName = name;
            this.modelEmail = email;
        },

        profileClick(userId) {

            const auth = getAuth();

            if (auth.currentUser.uid == userId) {
                this.$router.push({ name: 'profile' });
                return;
            }

            sessionStorage.setItem("otherId", userId);
            this.$router.push({ name: 'other-profile' });
            return;

        },

        openMessage(){
            this.$router.push({ name: 'messages' });
        },

        timeFormat(date) {

            let newFormat;

            TimeAgo.addDefaultLocale(en);
            const timeAgo = new TimeAgo('en-US');
            newFormat = timeAgo.format(Number(date));

            return newFormat;

        },

        tipClick(sub) {

            this.modelId = sub.modelId;
            this.modelName = sub.modelName;
            this.modelUsername = sub.modelUserName;
            this.modelProfilePic = sub.modelProfilePic;
            this.modelEmail = sub.email;

        },

        async sendTip(){

            let balance, newBalance, uFullname, uEmail, uProfilePic, uUsername;

            this.loadingText = "Sendind tip to @" + this.modelUsername + "...";
            this.$refs.loadingModal.classList.add("bg-active");

            if (this.tip > 500000) {
                this.errorText = "Tips can not be larger than ₦ 500,000";
                this.$refs.loadingModal.classList.remove("bg-active");
                this.$refs.errorModal.classList.add("bg-active");
                return;
            }

            if (this.tip < 1000) {
                this.errorText = "Minimum amount for tips is ₦ 1000";
                this.$refs.loadingModal.classList.remove("bg-active");
                this.$refs.errorModal.classList.add("bg-active");
                return;
            }

            const auth = getAuth();

            //check balance
            if (auth.currentUser.uid == this.modelId) {
                this.errorText = "You can not send a tip to yourself...";
                this.$refs.loadingModal.classList.remove("bg-active");
                this.$refs.errorModal.classList.add("bg-active");
                return;
            }


            const userRef = doc(db, "Users", auth.currentUser.uid);
            const userSnap = await getDoc(userRef);

            if (userSnap.exists()) {
                balance = userSnap.data().balance;
                uUsername = userSnap.data().displayId;
                uFullname = userSnap.data().name;
                uProfilePic = userSnap.data().profilePic;
                uEmail = userSnap.data().email;

                if (balance < this.tip) {
                    this.errorText = "Insufficient balance. Please top up your account and try again.";
                    this.$refs.errorModal.classList.add("bg-active");
                    this.$refs.loadingModal.classList.remove("bg-active");
                    return;
                }
            }
            else {
                this.$router.push({ name: 'sign-in' });
                return;
            }

            newBalance = balance - this.tip;

            await updateDoc(userRef, {
                balance: newBalance,
            });

            const modelRef = doc(db, "Users", this.modelId);
            await updateDoc(modelRef, {
                earnings: increment(this.tip),
                tipBalance: increment(this.tip),
            });

            let mSecs = new Date().getTime() / 1000;
            let secs = 10000000000 / mSecs

            //update user transactions
            await addDoc(collection(db, "UserTrans"), {
                idD: "FBW" + Math.floor(1000000 + Math.random() * 9000000),
                type: "Withdrawal",
                title: "Sent tip",
                description: " Sent a tip of ₦ " + this.tip + " to @" + this.modelName,
                amount: this.tip,
                method: "Baesnap Wallet",
                date: serverTimestamp(),
                dateN: secs,
                status: "successful",
                userId: auth.currentUser.uid,
                fullName: this.modelName,
                username: this.modelUsername,
                profilePic: this.modelProfilePic,
                
            });

            //update model transactions
            await addDoc(collection(db, "UserTrans"), {
                idD: "FBD" + Math.floor(1000000 + Math.random() * 9000000),
                type: "Deposit",
                title: "Received tip",
                description: this.message,
                amount: this.tip,
                method: "Baesnap Wallet",
                date: serverTimestamp(),
                dateN: secs,
                status: "successful",
                userId: this.modelId,
                username: uUsername,
                fullName: uFullname,
                profilePic: uProfilePic,
                

            });

            //model notification

            if (this.modelId != auth.currentUser.uid) {

                const notiRef = doc(db, "Users", this.modelId);
                await updateDoc(notiRef, {
                    notiCount: increment(1),
                });

                let mSecs = new Date().getTime() / 1000;
                let secs = 10000000000 / mSecs

                await addDoc(collection(db, "UserNoti"), {
                    category: "Tips",
                    description: "Sent you a tip of ₦ " + this.tip,
                    ownerId: this.modelId,
                    userId: auth.currentUser.uid,
                    username: uUsername,
                    fullName: uFullname,
                    profilePic: uProfilePic,
                    email: uEmail,
                    date: serverTimestamp(),
                    dateN: secs,
                    postId: this.tipPostId,
                });

            }

            if (this.message == "") {
                this.message = "none";
            }

            axios.post('https://api.baesnap.com/v1/tip-mail', {
                toName: this.modelName,
                toEmail: this.modelEmail,
                username: uUsername,
                amount: Number(this.tip).toLocaleString("us-Us"),
                message: this.message
            })
                .then(function (response) {
                    console.log(response);

                })

            $('#sendTip').modal('hide');
            this.successText = "Tip sent successfully";
            this.$refs.successModal.classList.add("bg-active");
            this.$refs.loadingModal.classList.remove("bg-active");
        },

        async getSubList() {

            this.loadingText = "Getting subscriptions..."
            this.$refs.loadingModal.classList.add("bg-active");

            const auth = getAuth();
            const querySnapshot = await getDocs(collection(db, "UserSubs", auth.currentUser.uid, "Subs"), orderBy("startDate", "desc"));

            if (querySnapshot.docs.length > 0) {

                // document.getElementById("emptySubText").textContent = "No subscriptions yet...";

                querySnapshot.forEach(async (doc) => {

                    let a1 = Number(doc.data().startDate.seconds) * 1000;
                    let a2 = String(new Date(Number(doc.data().startDate.seconds) * 1000));
                    let a3 = String(new Date(Number(doc.data().endDate) * 1000));


                    let subObj = {

                        id: doc.id,
                        price: doc.data().price,
                        priceD: Number(doc.data().price).toLocaleString("us-US"),
                        dateFull: a2.slice(0, -45),
                        dateD: this.timeFormat(a1),
                        endDate: a3.slice(0, -45),
                        endDateD: this.timeFormat(doc.data().endDate),
                        status: doc.data().status,
                        modelId: doc.data().modelId,
                        modelName: doc.data().modelName,
                        modelUserName: doc.data().modelUserName,
                        modelProfilePic: doc.data().modelProfilePic,
                        modelProfileBack: "",
                        email: doc.data().email

                    }

                    this.subList.push(subObj);
                    let mIndex = this.subList.length - 1;
                    await this.getFullName(doc.id, doc.data().modelId, mIndex);

                    if (doc.data().status == 'active') {
                        this.subListA.push(subObj);
                        let mIndex2 = this.subListA.length - 1;
                        await this.getFullName2(doc.id, doc.data().modelId, mIndex2);
                    }
                    

                });

            }
            else{
                document.getElementById("emptySub").style.display = 'flex';
            }

            

            this.getSubListE();
        },

        async getSubListE() {

            const auth = getAuth();
            const querySnapshot = await getDocs(collection(db, "UserSubsE", auth.currentUser.uid, "SubsE"), orderBy("startDate", "desc"));

            if (querySnapshot.docs.length > 0) {

                

                querySnapshot.forEach(async (doc) => {

                    let a1 = Number(doc.data().startDate.seconds) * 1000;
                    let a2 = String(new Date(Number(doc.data().startDate.seconds) * 1000));
                    let a3 = String(new Date(Number(doc.data().endDate) * 1000));


                    let subObj = {

                        id: doc.id,
                        price: doc.data().price,
                        priceD: Number(doc.data().price).toLocaleString("us-US"),
                        dateFull: a2.slice(0, -45),
                        dateD: this.timeFormat(a1),
                        endDate: a3.slice(0, -45),
                        endDateD: this.timeFormat(doc.data().endDate),
                        status: doc.data().status,
                        modelId: doc.data().modelId,
                        modelName: doc.data().modelName,
                        modelUserName: doc.data().modelUserName,
                        modelProfilePic: doc.data().modelProfilePic,
                        modelProfileBack: "",
                        

                    }

                    this.subList.push(subObj);
                    let mIndex = this.subList.length - 1;
                    await this.getFullName(doc.id, doc.data().modelId, mIndex);

                    this.subListE.push(subObj);
                    let mIndex3 = this.subListE.length - 1;
                    await this.getFullName3(doc.id, doc.data().modelId, mIndex3);

                });

            }
            else{
                document.getElementById("emptySubE").style.display = 'flex';
            }

            this.$refs.loadingModal.classList.remove("bg-active");

        },

        async getFullName(id, modelId, mIndex) {

            let i = mIndex;

            const modelRef = doc(db, "Users", modelId);
            const modelSnap = await getDoc(modelRef);

            if (this.subList[i].id == id) {
                    
                    this.subList[i].modelName = modelSnap.data().name,
                    this.subList[i].modelUserName = modelSnap.data().displayId,
                    this.subList[i].modelProfilePic = modelSnap.data().profilePic,
                    this.subList[i].modelProfileBack = modelSnap.data().profileBackground

                }

        },

        async getFullName2(id, modelId, mIndex) {

            let i = mIndex;

            const modelRef = doc(db, "Users", modelId);
            const modelSnap = await getDoc(modelRef);

            if (this.subListA[i].id == id) {
                    
                    this.subListA[i].modelName = modelSnap.data().name,
                    this.subListA[i].modelUserName = modelSnap.data().displayId,
                    this.subListA[i].modelProfilePic = modelSnap.data().profilePic,
                    this.subListA[i].modelProfileBack = modelSnap.data().profileBackground

                }

        },

        async getFullName3(id, modelId, mIndex) {

            let i = mIndex;

            const modelRef = doc(db, "Users", modelId);
            const modelSnap = await getDoc(modelRef);

            if (this.subListE[i].id == id) {
                    
                    this.subListE[i].modelName = modelSnap.data().name,
                    this.subListE[i].modelUserName = modelSnap.data().displayId,
                    this.subListE[i].modelProfilePic = modelSnap.data().profilePic,
                    this.subListE[i].modelProfileBack = modelSnap.data().profileBackground

                }

        },

        async unSubscribe(modelId, modelUserName, modelProfilePic, modelName, modelEmail) {

            this.loadingText = "Unsubcribing ...";
            this.$refs.loadingModal.classList.add("bg-active");

            if(this.cancelSelect == "Other" && this.cancelOther == ""){
                this.errorText = "Please tpye in the reason for your cancellation";
                this.$refs.loadingModal.classList.remove("bg-active");
                this.$refs.errorModal.classList.add("bg-active");
                return

            }

            const auth = getAuth();

            await deleteDoc(doc(db, "UserSubs", auth.currentUser.uid, "Subs", modelId));

            await deleteDoc(doc(db, "UserFans", modelId, "Fans", auth.currentUser.uid));

            try {
                await deleteDoc(doc(db, "UserContact", auth.currentUser.uid, "Contact", modelId));
            }
            catch (err) {
                console.log(err)
            }

            try {
                await deleteDoc(doc(db, "UserContact", modelId, "Contact", auth.currentUser.uid));
            }
            catch (err) {
                console.log(err)
            }

            const modelRef = doc(db, "Users", modelId);
            await updateDoc(modelRef, {
                fanCount: increment(-1),
                fanCountN: increment(1)
            });

            let mSecs = new Date().getTime() / 1000;
            let secs = 10000000000 / mSecs
            //Noti
            await addDoc(collection(db, "UserNoti"), {
                category: "Subs",
                description: "Cancelled their subscription to your content",
                ownerId: modelId,
                userId: auth.currentUser.uid,
                username: sessionStorage.getItem("userName"),
                fullName: sessionStorage.getItem("fullName"),
                profilePic: sessionStorage.getItem("profilePic"),
                email: sessionStorage.getItem("email"),
                date: serverTimestamp(),
                dateN: secs,
                postId: "",
            });

            let reason = this.cancelSelect;

            if(this.cancelSelect == "Other"){
                reason = this.cancelOther;
            }

            //SEND MAIL TO MODEL
            axios.post('https://api.baesnap.com/v1/cancelled-sub-mail', {
                toName: modelName,
                toEmail: modelEmail,
                username: "@" +sessionStorage.getItem("userName"),
                reason: reason
            })
            .then(function (response) {
                //console.log(response);

            })

            this.successText = "Successfully unsubcribed from @" + modelUserName;
            this.$refs.loadingModal.classList.remove("bg-active");
            this.$refs.successModal.classList.add("bg-active");

        },

        subscribe(sub) {
            sessionStorage.setItem("expiredSubId", sub.id);
            sessionStorage.setItem("otherId", sub.modelId);
            this.$router.push({ name: 'sub-pay' });
        },

    }

}
</script>